export default function searchResultsInit() {
  const wrapperOuter = document?.querySelector(".search-results-wrapper");
  const searchForm = wrapperOuter?.querySelector(".js-search-results-form");
  const searchInput = searchForm?.querySelector("input[type='search']");
  const submitBtn = searchForm?.querySelector("button[type='submit']");

  const seedRecentSearches = () => {
    const recentSearches = JSON.parse(localStorage.getItem("recentSearches"));
    if (!recentSearches || !recentSearches.length) return;
    const wrapper = document?.querySelector(".js-recent-search-results-wrapper");
    const list = document?.querySelector(".js-recent-search-results-list");
    const template = list?.querySelector(".js-recent-search-results-template");

    if (list) {
      list.innerHTML = "";
    }

    recentSearches.forEach((term) => {
      const clone = template?.cloneNode(true);

      if (clone) {
        clone.querySelector("span").innerText = term;
        clone.classList.remove("js-recent-search-results-template");
      }

      if (list) {
        list.appendChild(clone);
      }
    });

    if (wrapper) {
      wrapper.classList.remove("--is-hidden");
    }
  };

  searchInput?.addEventListener("input", () => {
    submitBtn.disabled = searchInput.value.length <= 0;
  });

  searchForm?.addEventListener("submit", (e) => {
    e.preventDefault();

    let recentSearches = JSON.parse(localStorage.getItem("recentSearches"));

    if (recentSearches && recentSearches.length) {
      recentSearches.unshift(searchInput.value);
    } else {
      recentSearches = [searchInput.value];
    }

    localStorage.setItem("recentSearches", JSON.stringify(recentSearches.slice(0, 5)));

    searchForm.submit();
  });

  seedRecentSearches();
}
